import { Box, Text } from '@chakra-ui/react';
import { useState } from 'react';
import Select from 'react-select';
import { useCurrentColors } from '../../hooks/UseCurrentColors/UseCurrentColors';
import { CustomSelect } from './style';
import {
    ClearIndicator,
    MultiValueLabel,
    MultiValueRemove,
    getCommonStyles,
    getDropdownIndicator,
    getMultiSelectStyles,
} from './utils';

function CanopySelect({
    title,
    components,
    styles = {},
    formatOptionLabel,
    ...props
}: any) {
    const currentColors = useCurrentColors();
    const [ref, setRef] = useState<any>(null);

    return (
        <Box width={props?.width || '100%'}>
            {title && (
                <Text
                    color={currentColors.brand['10']}
                    fontSize="15px"
                    fontWeight="bold"
                    mb="10px"
                >
                    {title}
                </Text>
            )}
            <Box>
                <CustomSelect
                    $currentColors={currentColors}
                    $styleProps={props}
                >
                    <Select
                        menuPortalTarget={
                            (window as any).skeleton
                                ? document.querySelector('skeleton-nav')
                                : document.body
                        }
                        menuPlacement="auto"
                        maxMenuHeight={150}
                        isSearchable={true}
                        ref={setRef}
                        {...{ formatOptionLabel }}
                        classNamePrefix="react-select"
                        styles={
                            props?.isMulti
                                ? {
                                      ...getMultiSelectStyles(
                                          currentColors,
                                          props
                                      ),
                                      ...styles,
                                  }
                                : {
                                      ...getCommonStyles(currentColors, props),
                                      ...styles,
                                  }
                        }
                        components={{
                            MultiValueLabel,
                            MultiValueRemove,
                            DropdownIndicator:
                                getDropdownIndicator(currentColors),
                            ClearIndicator,
                            ...components,
                        }}
                        {...props}
                    />
                </CustomSelect>
            </Box>
        </Box>
    );
}

export default CanopySelect;
